import { LoadState } from "../../../constants/enums";



export interface IJeTypeAndEntryState {
  jeType: {
    list: IJeType[];
    listLoading: LoadState;
    data: IJeType;
    loading: LoadState;
    error: string | null;
  };
  jeEntry: {
    list: IJeEntry[];
    listLoading: LoadState;
    data: IJeEntry[];
    loading: LoadState;
    error: string | null;
  };
}

export interface IJeEntry {
  unique_je_code: string | null;
  je_entry_number: string | null;
  type: string | null;
  gl_account: string | null;
  gl_account_name: string | null;
  branch_code: string | null;
  transaction_date: string | null;
  transaction_type: string | null;
  debit: string | null;
  credit: string | null;
  description: string | null;
  reference_info: string | null;
  reference_number: string | null;
  year_open: string | null;
  month_open: string | null;
  comment: string | null;
  reconciled: string | null;
  reconciled_date: string | null;
  status: string;
}

export interface IJeType {
  je_type_number: number | null;
  je_type: string | null;
  gl_account: string | null;
  gl_account_name: string | null;
  comment: string | null;
  status: string;
}

export const initialJeTypeAndEntryState: IJeTypeAndEntryState = {
  jeEntry: {
    list: [],
    listLoading: LoadState.NotLoaded,
    data: [
      {
        unique_je_code: null,
        je_entry_number: null,
        type: null,
        gl_account: null,
        gl_account_name: null,
        branch_code: null,
        transaction_date: null,
        transaction_type: "",
        debit: null,
        credit: null,
        description: null,
        reference_info: null,
        reference_number: null,
        year_open: null,
        month_open: null,
        comment: null,
        reconciled: null,
        reconciled_date: null,
        status: "ACTIVE",
      },
    ],
    loading: LoadState.NotLoaded,
    error: null,
  },
  jeType: {
    list: [],
    listLoading: LoadState.NotLoaded,
    data: {
      je_type_number: null,
      je_type: null,
      gl_account: null,
      gl_account_name: null,
      comment: null,
      status: "ACTIVE",
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
};
